module.exports = __webpack_public_path__ + "img/1484727793.2b2862f1.jpg";